import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import CommonTextField from "components/common/CommonTextField";

const EditUserModal = ({ isOpen, onClose, onSubmit, profile }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (!isOpen || !profile) return;

    setFirstName(profile?.firstname ?? "");
    setLastName(profile?.lastname ?? "");
    setEmail(profile?.email ?? "");
    setMobile(profile?.mobile ?? "");
    setPassword("");
  }, [isOpen, profile]);

  const handleSave = () => {
    const payload = {
      id: profile?._id ?? profile?.id,
      firstname: firstName,
      lastname: lastName,
      email,
      mobile,
    };

    if (password) {
      payload.password = password;
    }

    onSubmit?.(payload);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-xl p-6 flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-lg font-semibold">Edit User</h2>
          <button onClick={onClose}>
            <IoCloseOutline size={24} />
          </button>
        </div>

        {/* Form */}
        <div className="space-y-4">
          <CommonTextField
            label="First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />

          <CommonTextField
            label="Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />

          <CommonTextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <CommonTextField
            label="Mobile"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
          />

          <CommonTextField
            label="New Password (optional)"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        {/* Actions */}
        <div className="flex mt-6 gap-3">
          <button
            onClick={onClose}
            className="w-1/2 bg-gray-200 py-2 rounded-md"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="w-1/2 bg-blue-600 text-white py-2 rounded-md"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditUserModal;
